import PropTypes from 'prop-types';
import DispositionService from "./DipositionService";
import BaseSelectorReadonlyToInputV2 from "../component/Select/BaseSelectorReadonlyToInputV2";

class DispositionSelector extends BaseSelectorReadonlyToInputV2 {

  constructor(props) {
    super(props, 'friendlyName', 'id');
    this.state = {
      ...this.state,
      title: props.title || 'Disposição',
      url: DispositionService.ALL_URL+ '/combobox'
    };
  }
}

DispositionSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.any,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DispositionSelector;



// WEBPACK FOOTER //
// ./src/disposition/DispositionSelector.js